import React from 'react'

import { useSelector } from 'react-redux'
import { selectCloningStep } from '../../reducers/cloning_steps'

import LeaguesBrowser from '../leaguesBrowser/LeaguesBrowser'
import LeaguesRename from '../leaguesRename/LeaguesRename'
import LeaguesConfig from '../leaguesConfig/LeaguesConfig'
import LeaguesDates from '.././leaguesDates/LeaguesDates'
import { CloningStepsEnum } from '../../constants'
import useCloningStepsEffects from '../../hooks/useCloningStepsEffects'
import useSyncSessionURL from '../../hooks/useSyncSessionURL'

const renderingDict = {
  [CloningStepsEnum.BROWSE]: <LeaguesBrowser/>,
  [CloningStepsEnum.RENAME]: <LeaguesRename/>,
  [CloningStepsEnum.CONFIG]: <LeaguesConfig/>,
  [CloningStepsEnum.DATES]: <LeaguesDates/>,
}

const LeaguesView = () => {
  const cloningStep = useSelector(selectCloningStep)
  useCloningStepsEffects()
  useSyncSessionURL()
  return renderingDict[cloningStep]
}

export default LeaguesView
